export const POSITION_ARRAYS = ['left', 'center', 'right', 'defense', 'goalie'];